export const GET_FEES_SUCCESS = "GET_FEES_SUCCESS";

export const GET_FEES = "GET_FEES";
